import { APITransport } from '@client/transports/api';

export const DomainService = {
  checkSSLCertificate() {
    return APITransport.post({
      path: '/rest/domain/execute/checksslcertificate',
      body: {}
    });
  },
  requestSSLCertificate() {
    return APITransport.post({
      path: '/rest/domain/execute/requestsslcertificate',
      body: {}
    });
  },
  getRelayPassword() {
    return APITransport.post({
      path: '/rest/domain/execute/getrelaypassword',
      body: {}
    });
  },
  getMXDomain() {
    return APITransport.post({
      path: '/rest/domain/execute/geno365mx',
      body: {}
    });
  },
  getEBC() {
    return APITransport.post({
      path: '/rest/user/execute/ebcdata',
      body: {
        debounceQuery: '',
        page: 0,
        perPage: 10,
        query: ''
      }
    });
  },
  async getFields(query) {
    const userParams = await APITransport.get({
      path: '/rest/listofvalues/listuserparams',
      query
    });

    const params = Array.isArray(userParams) ? userParams : [];

    return [...new Set(params.map((param) => param.name))].sort();
  },
  getFtpFolder() {
    return APITransport.post({
      path: '/rest/domain/execute/getftpfolder'
    });
  },
  getFtpFile() {
    return APITransport.post({
      path: '/rest/domain/execute/getftpfile'
    });
  },
  getSftpPassword() {
    return APITransport.post({
      path: '/rest/domain/execute/getsftpserverpassword'
    });
  },
  getSettings() {
    return APITransport.get({
      path: '/rest/domain/domainsettings'
    });
  },
  getBillingIdUsage({ billingid }) {
    return APITransport.post({
      path: '/rest/user/execute/usagedata_billingid',
      body: {
        billingid
      }
    });
  },
  getUsage({ domainname }) {
    return APITransport.post({
      path: '/rest/user/execute/usagedata',
      body: {
        domainname
      }
    });
  },
  switch(token, domain) {
    return APITransport.post({
      path: '/rest/login',
      body: {
        token,
        switchDomain: domain
      },
      cancellable: false
    });
  },
  updateSettings(body) {
    return APITransport.post({
      path: '/rest/domain/domainsettings/save',
      body
    });
  }
};
